var React = require('react');

function Asterisk (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"asterisk","key":2},React.createElement("polygon",{"id":"Shape","points":"8 0 12 0 11.21 7.91 17.66 3.27 19.66 6.73 12.42 10 19.66 13.27 17.66 16.73 11.21 12.09 12 20 8 20 8.79 12.09 2.34 16.73 0.34 13.27 7.58 10 0.34 6.73 2.34 3.27 8.79 7.91"}))]);
}

Asterisk.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Asterisk;

Asterisk.default = Asterisk;
